import { View } from 'react-native';
import Svg, { Circle, G, Path } from 'react-native-svg';
import { brand, colors, fonts, logoMark } from '@hogar/shared';
import { Txt, useT } from './ui';

/** The house with a speech bubble (decision 63). */
export function LogoMark({ height = 44 }: { height?: number }) {
  const m = logoMark;
  return (
    <Svg width={(height * m.width) / m.height} height={height} viewBox={m.viewBox} fill="none">
      <G stroke={m.colors.house} strokeWidth={m.strokeWidth} strokeLinecap="round" strokeLinejoin="round">
        {m.house.map((d) => (
          <Path key={d} d={d} />
        ))}
      </G>
      <Path d={m.bubble} fill={m.colors.bubble} />
      {m.dots.map((dot) => (
        <Circle key={dot.cx} cx={dot.cx} cy={dot.cy} r={dot.r} fill={m.colors.dots} />
      ))}
    </Svg>
  );
}

/** Stacked logo: the mark, the name in Lora, and the handwritten tagline in the owner's language. */
export function Logo({ size = 1, tagline = true }: { size?: number; tagline?: boolean }) {
  const { lang } = useT();
  return (
    <View style={{ alignItems: 'center' }}>
      <LogoMark height={52 * size} />
      <Txt style={{ fontFamily: fonts.logo, fontSize: 34 * size, lineHeight: 42 * size, marginTop: 6 * size }} color={colors.text}>
        {brand.wordmark}
      </Txt>
      {tagline && brand.showTagline && (
        <Txt style={{ fontFamily: fonts.hand, fontSize: 19 * size, lineHeight: 24 * size }} color={colors.primary}>
          {brand.tagline[lang]}
        </Txt>
      )}
    </View>
  );
}
